module.exports = __webpack_public_path__ + "img/colaboradores_icone.acae7077.png";